import { render, staticRenderFns } from "./WebsitePhpWizard.vue?vue&type=template&id=8edb0ee2&scoped=true&"
import script from "./WebsitePhpWizard.vue?vue&type=script&lang=js&"
export * from "./WebsitePhpWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edb0ee2",
  null
  
)

export default component.exports